/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { AddUpdateCourts } from "../../sub-modules";
import { CreateCourt } from "../../utilities/api/courts";
import { CourtDetailType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";


const AddCourt = () => {

    const navigate = useNavigate()
    const { SelectedFacility } = useAppSelector(state => state.facilityList)
    const [courtData, setCourtData] = useState<CourtDetailType>({
        name: "",
        facilityId: SelectedFacility ? Number(SelectedFacility) : 1,
        sportId: "",
        openTime: "",
        closeTime: "",
        preBookingMaxDays: null,
        isActive: "true",
        rates: []
    })
    const [submitButton, setSubmitButton] = useState(false)

    useEffect(() => {
        setCourtData({ ...courtData, facilityId: Number(SelectedFacility) })
    }, [SelectedFacility])

    const handleCreateUpdate = async (payload: CourtDetailType) => {
        setSubmitButton(true)
        const result = await CreateCourt(payload)
        if (result.status === 200) {
            navigate("/courts")
        }
        else {
            toast.error(result.response.data.message);
        }
        setSubmitButton(false)
    }

    return (
        <>
            <AddUpdateCourts name="Add Court" courtData={courtData} setCourtData={setCourtData} handleCreateUpdate={handleCreateUpdate} submitButton={submitButton} />
            <ToastContainer />
        </>
    )
}
export { AddCourt }
